import { useNavigate } from "react-router-dom";
import { Sparkles, MonitorSmartphone, LogOut } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { enterPortal } from "@/lib/mode";

export default function ChooseMode() {
  const navigate = useNavigate();
  const { user, logout } = useAuth();

  const goPractitioner = () => navigate("/practitioner", { replace: true });
  const goPortal = () => {
    enterPortal();
    navigate("/portal", { replace: true });
  };

  return (
    <div className="soma-grain relative flex min-h-screen flex-col items-center justify-center bg-soma-surface px-5 py-10">
      <button
        onClick={() => { logout(); navigate("/login", { replace: true }); }}
        data-testid="choose-logout"
        className="absolute right-5 top-5 flex items-center gap-2 text-xs text-soma-muted hover:text-soma-on"
      >
        <LogOut size={15} /> Sign out
      </button>

      <div className="mb-10 text-center">
        <p className="font-mono text-[11px] uppercase tracking-[0.35em] text-soma-brand">// soma linea</p>
        <h1 className="mt-2 font-display text-4xl italic text-soma-on md:text-5xl">
          Welcome, {user?.full_name?.split(" ")[0] || "friend"}.
        </h1>
        <p className="mt-2 text-sm text-soma-on2">How will you hold the space today?</p>
      </div>

      <div className="grid w-full max-w-3xl grid-cols-1 gap-5 md:grid-cols-2">
        <button
          onClick={goPractitioner}
          data-testid="choose-practitioner"
          className="group flex flex-col items-start gap-4 rounded-3xl border border-soma-border bg-soma-surface2 p-7 text-left transition-colors hover:border-soma-brand"
        >
          <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-soma-brand/15 text-soma-brand">
            <Sparkles size={26} />
          </div>
          <div>
            <p className="font-display text-2xl text-soma-on">I&apos;m the practitioner</p>
            <p className="mt-1 text-sm text-soma-on2">
              You guide the reading — capture, reveal, and share the take-home keepsake yourself.
            </p>
          </div>
        </button>

        <button
          onClick={goPortal}
          data-testid="choose-portal"
          className="group flex flex-col items-start gap-4 rounded-3xl border border-soma-border bg-soma-surface2 p-7 text-left transition-colors hover:border-soma-brand"
        >
          <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-soma-brand/15 text-soma-brand">
            <MonitorSmartphone size={26} />
          </div>
          <div>
            <p className="font-display text-2xl text-soma-on">Open the Palm Portal</p>
            <p className="mt-1 text-sm text-soma-on2">
              A self-guided experience to leave up — guests read their own palms, start to finish.
            </p>
          </div>
        </button>
      </div>
    </div>
  );
}
